import React from "react";
import { Modal, Form, Row, Col, Button, AutoComplete, Input } from "antd";

const FormItem = Form.Item;

export default class DoctorCertificateModal extends React.Component {
  render() {
    const {
      showCertificateModal,
      toggleCertificateModal,
      regPhotoUrl
    } = this.props;
    return (
      <Modal
        title={null}
        className="certificate-title kc-modal-large"
        visible={showCertificateModal}
        onCancel={toggleCertificateModal}
        maskClosable={false}
        footer={null}
      >
        <Row>
          <Col span={24} className="text-center">
            <img className="certificate-img" src={regPhotoUrl}></img>
          </Col>
        </Row>
      </Modal>
    );
  }
}
